import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class ActiveEventNotificationGroup extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'ActiveEventNotificationGroup';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventGuestId: null,
            notificationGroupId: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.items) {
    //         data.items = new models.api.NotificationGroup(data.NotificationGroup)
    //     }
    //     return data
    // }
}

const servicePath = 'active-notification-groups';
const servicePlugin = makeServicePlugin({
    Model: ActiveEventNotificationGroup,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin